<ng-container *ngIf="isSelectedMenuSystemproof">
  <div class="d-flex sections-nav">
    <div class="action-menu p3" [ngClass]="{'menu-selected': isHomeCampaignPage }">
      <button class="btn" [routerLink]="SYSTEMPROOF_URL" [disabled]="appStatus.isEditionOngoing">
        <mat-icon>home</mat-icon>
        <span> Home</span>
      </button>
    </div>
    <div class="action-menu p3" [ngClass]="{'menu-selected': isSelectedSubMenuSystems}" > 
      <button class="btn" [routerLink]="SYSTEMS_URL" [disabled]="appStatus.isEditionOngoing">
        <mat-icon>fact_check</mat-icon>
        <span> Driving Automation Systems</span>
      </button>
    </div>
    <div class="action-menu p3" [ngClass]="{'menu-selected': isSelectedSubMenuCampaigns }" >
      <button class="btn" [routerLink]="CAMPAIGNS_URL" [disabled]="appStatus.isEditionOngoing">
        <mat-icon>view_list</mat-icon>
        <span> Campaigns</span>
      </button>
    </div>
    <div class="action-menu p3" [ngClass]="{'menu-selected': isSelectedSubMenuUsecases}" >
      <button class="btn" [routerLink]="USECASES_URL" [disabled]="appStatus.isEditionOngoing" attr.data-cy="useCaseBreadcrumbButton">
        <mat-icon>commute</mat-icon>
        <span> Use-cases</span>
      </button>
    </div>
    <div class="action-menu p3" [ngClass]="{'menu-selected': isSelectedSubMenuTestsProtocol}" > 
      <button class="btn" [routerLink]="TESTS_PROTOCOL_URL" [disabled]="appStatus.isEditionOngoing">
        <mat-icon>fact_check</mat-icon>
        <span> Test Protocols</span>
      </button>
    </div>
  </div>
</ng-container>

<nav>
  <ol class="breadcrumb">
    <li class="breadcrumb-item text-capitalize" *ngIf="isHomeCampaignPage && !isSelectedMenuScenario && !isSelectedMenuCollection">
      <a class="disabled">Home</a>
    </li>
    <li class="breadcrumb-item" *ngIf="isSelectedMenuScenario  || isSelectedMenuCollection">
      <a [routerLink]="initialPath"><mat-icon class="mx-2" >home</mat-icon></a>
    </li>
    <li class="breadcrumb-item text-capitalize" *ngFor="let pathItem of pathItems; let i = index">
        <a [routerLink]="pathItem.route" routerLinkActive="active" [class.disabled]="appStatus.isEditionOngoing || i === pathItems.length - 1">
          {{ pathItemsLabels[i] }}
        </a>
    </li>
  </ol>
</nav>